import {
  mdCheckup,
  messageState,
  modalNoEdit
} from 'Pages/MessageCheckupSummary/recoil/state/message'
import {
  modalManageAlertsState,
  modalSendingState
} from 'Pages/MessageCheckupSummary/recoil/state/modals'
import { pageState } from 'Pages/MessageCheckupSummary/recoil/state/page'

import { ENTITY_TYPE_AUTOMATION_WORKFLOW, ENTITY_TYPE_TRIGGER } from 'Constants'
import {
  EmailMessageCheckUpIssueType,
  LOGIN_TYPE_WEBLOGIN,
  MESSAGE_STR_TYPE_CONTENTSCAMPAIGN,
  STORE_KEY_LOGIN_TYPE
} from 'Constants/'
import getIntl from 'Helpers/intl'
import { storeGet } from 'Helpers/localStorage'
import { logAppError } from 'Helpers/logger'
import { pendoTrack } from 'Helpers/pendoTracking'
import { notifyParent } from 'mailup-react-helpers'
import {
  addSilencedAlerts,
  checkMessage,
  getAllEntitiesThatUseMessage,
  getMessageDetails,
  getSilencedAlerts,
  getWhitelist,
  isSendingMessage,
  modalCheck,
  updateIssueVisibility,
  updateWhitelist
} from '../actions/actions'

export const initCallback = ({ set }) => async id => {
  set(pageState, prev => ({ ...prev, loading: true }))

  try {
    const [{ subject, ...messageDetails }, checkup] = await Promise.all([
      getMessageDetails(id),
      checkMessage(id)
    ])

    set(messageState, prev => ({
      ...prev,
      ...messageDetails,
      checkup
    }))
    set(pageState, prev => ({ ...prev, title: subject, loaded: true }))
  } catch (error) {
    console.error('### error', error)
    logAppError({
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  set(pageState, prev => ({ ...prev, loading: false }))
}

export const editCallback = ({ set, snapshot }) => async ({ onRedirect }) => {
  set(pageState, prev => ({ ...prev, loading: true }))

  const { id, isBee, messageType, idCampaign } = await snapshot.getPromise(
    messageState
  )

  try {
    const isSending = await isSendingMessage(id)

    set(modalSendingState, prev => ({ ...prev, show: isSending }))

    if (!isSending) {
      if (isBee && messageType === MESSAGE_STR_TYPE_CONTENTSCAMPAIGN) {
        notifyParent('redirectMainFrame', [
          `App.aspx#/beePluginEditor/editCMP/${idCampaign}`
        ])
      }
      if (isBee && messageType !== MESSAGE_STR_TYPE_CONTENTSCAMPAIGN) {
        onRedirect(`/messages/email/bee/edit/${id}`)
      }
      if (!isBee) {
        notifyParent('redirectMainFrame', [
          `form_upd_newsletter.aspx?source=listemail&idNL=${id}`
        ])
      }
    } else {
      set(pageState, prev => ({
        ...prev,
        inlineMessage: getIntl().formatMessage({
          id: 'Load.EmailMessageList.MessageIsOnSentWarning'
        }),
        inlineMessageSeverity: 'warning'
      }))
      set(modalNoEdit, prev => ({
        ...prev,
        default: true
      }))
    }
  } catch (error) {
    console.error('### error', error)
    logAppError({
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  set(pageState, prev => ({ ...prev, loading: false }))
}

export const mdCheckupStateCallback = ({ set }) => async idMessage => {
  set(pageState, prev => ({ ...prev, loading: true }))

  try {
    const [
      mdCheck,
      workflowsEntities,
      silencedAlerts,
      whiteList
    ] = await Promise.all([
      modalCheck(idMessage),
      getAllEntitiesThatUseMessage(idMessage),
      getSilencedAlerts(),
      getWhitelist(idMessage)
    ])

    const tmpWorkflows = workflowsEntities.filter(
      ({ Type, Name }) =>
        (Type === ENTITY_TYPE_TRIGGER ||
          Type === ENTITY_TYPE_AUTOMATION_WORKFLOW) &&
        !Name.startsWith('AutomationWorkflowTrigger')
    )
    const workflows = tmpWorkflows.length > 0
    set(mdCheckup, prev => ({
      ...prev,
      workflowsEntities: tmpWorkflows
    }))

    const silencedAlertsArray =
      silencedAlerts.DataValue && silencedAlerts.DataValue !== ''
        ? typeof JSON.parse(silencedAlerts.DataValue) === 'string'
          ? []
          : JSON.parse(silencedAlerts.DataValue)
        : []

    if (silencedAlertsArray.length > 0) {
      silencedAlertsArray.forEach(e => {
        e.stateManaged = false
        e.silenced =
          e.disableForMessage.length > 0
            ? e.disableForMessage.includes(idMessage.toString())
              ? 'silent'
              : 'enable'
            : e.enable
            ? 'enable'
            : 'disable'
      })
    }
    Object.keys(EmailMessageCheckUpIssueType).forEach(e => {
      const index = silencedAlertsArray.findIndex(
        f => f.issueType === EmailMessageCheckUpIssueType[e]
      )
      if (index === -1) {
        const obj = {
          stateManaged: false,
          silenced: 'enable',
          issueType: EmailMessageCheckUpIssueType[e]
        }
        silencedAlertsArray.push(obj)
      }
    })
    set(mdCheckup, prev => ({
      ...prev,
      silencedAlertsArray: silencedAlertsArray
    }))
    if ('CheckFields' in mdCheck) {
      const seeOption =
        mdCheck.CheckFields.IsDynamicFieldsEnabled === false &&
        mdCheck.CheckFields.ContainsDynamicFields === true
      set(mdCheckup, prev => ({
        ...prev,
        dynamicFieldsOptionEnabled: seeOption
      }))

      if (mdCheck.CheckFields.WrongDynamicTags.length > 0) {
        const whitelisted =
          whiteList.DataValue && whiteList.DataValue !== ''
            ? JSON.parse(whiteList.DataValue)
            : []

        let newWrongTags = mdCheck.CheckFields.WrongDynamicTags.slice(0)
        newWrongTags = newWrongTags.filter(m => m.Value !== '[]')
        // pendo
        newWrongTags.forEach(e => {
          const pendoProps = {
            IdMessage: idMessage,
            Value: e.Value.replace(/[[\]]/g, ''),
            Location: e.Location,
            SilentMode: whitelisted.includes(e.Value.replace(/[[\]]/g, '')),
            AlertStatus: 'Enabled',
            Source: 'overview'
          }
          pendoTrack('Checkup - dynamic field - impression', pendoProps)
        })
        const tmpWhiteListItems = []
        whitelisted.forEach(element => {
          const i = newWrongTags.findIndex(
            e => e.Value.replace(/[[\]]/g, '') === `${element}`
          )
          if (i > -1) {
            // newWrongTags.splice(i, 1)
            tmpWhiteListItems.push(element)
          }
        })

        set(mdCheckup, prev => ({
          ...prev,
          wrongDynamicTags: newWrongTags,
          addToWhiteList: tmpWhiteListItems
        }))
      }
    }

    if (mdCheck) {
      set(mdCheckup, prev => ({
        ...prev,
        checkBlacklistResult: mdCheck.CheckBlacklistResult,
        checkLiquidCode: mdCheck.CheckLiquidCode,
        checkAttachments: mdCheck.CheckAttachments,
        checkDynamicContents: mdCheck.CheckDynamicContents,
        checkSize: mdCheck.CheckSize,
        checkContent: mdCheck.CheckContent,
        checkLinksWoTracking: mdCheck.CheckLinksWoTracking,
        checkUnsubscribeLink: mdCheck.CheckUnsubscribeLink,
        checkMaxSize: mdCheck.CheckMaxSize,
        checkPreheader: mdCheck.CheckPreheader,
        checkWebAnalytics: mdCheck.CheckWebAnalytics,
        checkWorkflowWarning: workflows
      }))
    }
  } catch (error) {
    console.error('### error', error)
    logAppError({
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
  set(pageState, prev => ({ ...prev, loading: false }))
}

export const callbackManagerAlert = ({ set, snapshot }) => async idMessage => {
  set(pageState, prev => ({ ...prev, loading: true }))
  set(modalManageAlertsState, prev => ({
    ...prev,
    show: false
  }))
  const { silencedAlertsArray, addToWhiteList } = await snapshot.getPromise(
    mdCheckup
  )

  try {
    const silencedAlerts = await getSilencedAlerts()
    const silencedAlertsArrayUpdated =
      silencedAlerts.DataValue && silencedAlerts.DataValue !== ''
        ? JSON.parse(silencedAlerts.DataValue)
        : []
    silencedAlertsArray.forEach(e => {
      // vedo se è cambiato lo stato
      if (e.stateManaged) {
        const index = silencedAlertsArrayUpdated.findIndex(
          f => f.issueType === e.issueType
        )
        if (index > -1) {
          // esiste
          if (e.silenced === 'disable') {
            silencedAlertsArrayUpdated[index].enable = false
            silencedAlertsArrayUpdated[index].disableForMessage = []
          } else if (e.silenced === 'enable') {
            // abilitato
            silencedAlertsArrayUpdated[index].enable = true
            silencedAlertsArrayUpdated[index].disableForMessage = []
          } else if (e.silenced === 'silent') {
            silencedAlertsArrayUpdated[index].enable = undefined
            const exsist = silencedAlertsArrayUpdated[
              index
            ].disableForMessage.includes(idMessage.toString())
            if (!exsist) {
              silencedAlertsArrayUpdated[index].disableForMessage.push(
                idMessage.toString()
              )
            }
          }
        } else {
          const obj = {
            issueType: e.issueType,
            disableForMessage: []
          }
          if (e.silenced === 'disable') {
            obj.enable = false
          } else if (e.silenced === 'enable') {
            obj.enable = true
          } else if (e.silenced === 'silent') {
            obj.enable = undefined
            obj.disableForMessage.push(idMessage.toString())
          }
          silencedAlertsArrayUpdated.push(obj)
        }
      }
    })
    const loginType = storeGet(STORE_KEY_LOGIN_TYPE)
    // il servizio restituisce lo stato
    // aggiornato, quello che sto salvando
    let resAlets = ''
    const loginTypeWL = loginType === LOGIN_TYPE_WEBLOGIN
    // await addSilencedAlerts(silencedAlertsArrayUpdated)
    if (loginTypeWL) {
      resAlets = await addSilencedAlerts(silencedAlertsArrayUpdated)
    }

    const resSilAlets = loginTypeWL
      ? resAlets.DataValue && resAlets.DataValue !== ''
        ? JSON.parse(resAlets.DataValue)
        : []
      : // se però non sono in WEBLOGIN
        // resta lo stato corrente
        silencedAlertsArrayUpdated

    if (resSilAlets.length > 0) {
      resSilAlets.forEach(e => {
        e.stateManaged = false
        e.silenced =
          e.disableForMessage.length > 0
            ? e.disableForMessage.includes(idMessage.toString())
              ? 'silent'
              : 'enable'
            : e.enable
            ? 'enable'
            : 'disable'
      })
    }
    Object.keys(EmailMessageCheckUpIssueType).forEach(e => {
      const index = resSilAlets.findIndex(
        f => f.issueType === EmailMessageCheckUpIssueType[e]
      )
      if (index === -1) {
        const obj = {
          stateManaged: false,
          silenced: 'enable',
          issueType: EmailMessageCheckUpIssueType[e]
        }
        resSilAlets.push(obj)
      }
    })
    set(mdCheckup, prev => ({
      ...prev,
      silencedAlertsArray: resSilAlets
    }))
    if (loginType === LOGIN_TYPE_WEBLOGIN) {
      await updateWhitelist(idMessage, addToWhiteList)
    }
    set(modalManageAlertsState, prev => ({
      ...prev,
      canSaveFromPage: true
    }))
  } catch (error) {
    console.error('### error', error)
    logAppError({
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      loading: false,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
  set(pageState, prev => ({
    ...prev,
    loading: false
  }))
}

export const callbackResetManagerAlert = ({
  set,
  snapshot
}) => async idMessage => {
  set(pageState, prev => ({ ...prev, loading: true }))
  set(modalManageAlertsState, prev => ({
    ...prev,
    show: false
  }))

  try {
    const silencedAlerts = await getSilencedAlerts()
    const silencedAlertsArrayUpdated =
      silencedAlerts.DataValue && silencedAlerts.DataValue !== ''
        ? JSON.parse(silencedAlerts.DataValue)
        : []
    if (silencedAlertsArrayUpdated.length > 0) {
      silencedAlertsArrayUpdated.forEach(e => {
        e.stateManaged = false
        e.silenced =
          e.disableForMessage.length > 0
            ? e.disableForMessage.includes(idMessage.toString())
              ? 'silent'
              : 'enable'
            : e.enable
            ? 'enable'
            : 'disable'
      })
    }
    Object.keys(EmailMessageCheckUpIssueType).forEach(e => {
      const index = silencedAlertsArrayUpdated.findIndex(
        f => f.issueType === EmailMessageCheckUpIssueType[e]
      )
      if (index === -1) {
        const obj = {
          stateManaged: false,
          silenced: 'enable',
          issueType: EmailMessageCheckUpIssueType[e]
        }
        silencedAlertsArrayUpdated.push(obj)
      }
    })
    set(mdCheckup, prev => ({
      ...prev,
      silencedAlertsArray: silencedAlertsArrayUpdated
    }))
    set(modalManageAlertsState, prev => ({
      ...prev,
      canSaveFromPage: true
    }))
  } catch (error) {
    console.error('### error', error)
    logAppError({
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      loading: false,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
  set(pageState, prev => ({
    ...prev,
    loading: false
  }))
}

export const changeAlertCallback = ({ set, snapshot }) => async (
  key,
  value
) => {
  const { id } = await snapshot.getPromise(messageState)

  set(mdCheckup, ({ silencedAlertsArray, ...prev }) => ({
    ...prev,
    silencedAlertsArray: silencedAlertsArray.map(o => {
      return o.issueType === key
        ? {
            ...o,
            enable:
              value === 'enable'
                ? true
                : value === 'disable'
                ? false
                : undefined,
            disableForMessage:
              value === 'silent'
                ? o.disableForMessage
                  ? Array.from(new Set([...o.disableForMessage, `${id}`]))
                  : [`${id}`]
                : [],
            silenced: value
          }
        : o
    })
  }))

  try {
    await updateIssueVisibility(key, value, id)
  } catch (error) {
    console.error('### error', error)
    logAppError({
      appError: error
    })
  }
}
